import React from 'react';
import PropTypes from 'prop-types';
import styles from './Input.module.scss';

export default function Input({ placeholder, value, onChange, type,className, ...props }) {
  return (
    <div className={`${styles.container}`}>
      <input
        {...props}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={className} 
        autoComplete='off'
      />
    </div>
  );
}

// Define prop types for the Input component
Input.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
};
